export enum SortingOptions {
  latest = 'latest',
  rating = 'rating',
  culture = 'culture',
  oldest = 'oldest',
  pertinence = 'pertinence',
  bestseller = 'bestseller',
  nameAsc = 'name-asc-lang_$locale',
  nameDesc = 'name-desc-lang_$locale',
  priceAsc = 'price-asc',
  priceDesc = 'price-desc',
  // only for pages ALP, RLP
  alphabeticalAscending = 'alphabeticalAscending',
  alphabeticalDescending = 'alphabeticalDescending',
  priceAscending = 'priceAscending',
  priceDescending = 'priceDescending',
}

export const PLPSortingOptions = [
  SortingOptions.latest,
  SortingOptions.culture,
  SortingOptions.oldest,
  SortingOptions.pertinence,
  SortingOptions.bestseller,
  SortingOptions.nameAsc,
  SortingOptions.nameDesc,
  SortingOptions.priceAsc,
  SortingOptions.priceDesc,
];

export const SearchSortingOptions = [
  SortingOptions.latest,
  SortingOptions.culture,
  SortingOptions.oldest,
  SortingOptions.bestseller,
  SortingOptions.nameAsc,
  SortingOptions.nameDesc,
  SortingOptions.priceAsc,
  SortingOptions.priceDesc,
];

export const RLPSortingOptions = [
  SortingOptions.latest,
  SortingOptions.alphabeticalAscending,
  SortingOptions.alphabeticalDescending,
];

export const RecipeHistorySortingOptions = [SortingOptions.latest, SortingOptions.oldest];

export const ALPSortingOptions = [
  SortingOptions.latest,
  SortingOptions.alphabeticalAscending,
  SortingOptions.alphabeticalDescending,
];

// only for pages ALP, RLP
export const ctfSorts = {
  [SortingOptions.oldest]: 'sys.createdAt', // Ascending
  [SortingOptions.latest]: '-sys.createdAt', // Descending
  [SortingOptions.rating]: undefined, // TODO: in FRAZ-1005
  [SortingOptions.alphabeticalAscending]: 'fields.title',
  [SortingOptions.alphabeticalDescending]: '-fields.title',
  [SortingOptions.priceAscending]: 'fields.costPriceValue',
  [SortingOptions.priceDescending]: '-fields.costPriceValue',
};

export const SortTranslationCodes = {
  [SortingOptions.latest]: 'sortRlp.latest',
  [SortingOptions.alphabeticalAscending]: 'sortRlp.alphabeticalAscending',
  [SortingOptions.alphabeticalDescending]: 'sortRlp.alphabeticalDescending',
};

export const sorts = {
  [SortingOptions.latest]: [[(item) => Date.parse(item.sys.createdAt)], ['desc']],
  [SortingOptions.rating]: [], // TODO: in FRAZ-1005
  [SortingOptions.alphabeticalAscending]: [['fields.title'], ['asc']],
  [SortingOptions.alphabeticalDescending]: [['fields.title'], ['desc']],
  [SortingOptions.priceAscending]: [['fields.costPriceValue'], ['asc']],
  [SortingOptions.priceDescending]: [['fields.costPriceValue'], ['desc']],
};

export type SortingOption = {
  type: string;
  id: string;
  value: string;
};

export type SortingModel = {
  options: SortingOption[];
  selected: string;
};

export default {
  PLPSortingOptions,
  SearchSortingOptions,
  RLPSortingOptions,
  ALPSortingOptions,
  ctfSorts,
  SortTranslationCodes,
  sorts,
};
